module.exports = __webpack_public_path__ + "img/avator.a32db993.png";